import styled from 'styled-components'

export const Container = styled.div`
  display: block;
  max-width: 500px;
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(1px, 1fr));
  grid-gap: 20px;
`

export const SaveCreditCard = styled.div`
  input {
    margin-right: 10px;
  }
`
